// extracted by mini-css-extract-plugin
export var buttonContent = "_46-0";
export var centered = "_46-1";
export var centeredFlex = "_46-2";
export var errorText = "_46-3";
export var icon = "_46-4";
export var iconButtonContent = "_46-5";
export var monospace = "_46-6";
export var padded = "_46-7";